const DATE_ID = 1;
const MONTH_ID = 2;
const GROUP_ID = 3;
const FEEDBACK_MODE_OBJECT = {
  [DATE_ID]: {
    id: DATE_ID,
    name: "今日",
  },
  [MONTH_ID]: {
    id: MONTH_ID,
    name: "30日間の平均",
  },
  [GROUP_ID]: {
    id: GROUP_ID,
    name: "グループ",
  },
};
const FEEDBACK_MODES = Object.values(FEEDBACK_MODE_OBJECT);

const DATE_LEGEND_ITEM = {
  id: 1,
  name: "今日",
  backgroundColor: "#afafaf",
};
const YESTERDAY_LEGEND_ITEM = {
  id: 4,
  name: "昨日",
  backgroundColor: "#afafaf",
};
const MONTH_LEGEND_ITEM = {
  id: 2,
  name: "30日平均",
  backgroundColor: "#dbdbdb",
};
const LEGEND_GRID_TYPE = "LEGEND_GRID_TYPE";
const GROUP_LEGEND_ITEM = {
  id: 3,
  type: LEGEND_GRID_TYPE,
  name: "標準偏差",
  backgroundColor: "#fff",
  gridColor: "rgb(219, 219, 219)",
};

const DATE_LEGENDS = [DATE_LEGEND_ITEM];
const MONTH_LEGENDS = [YESTERDAY_LEGEND_ITEM, MONTH_LEGEND_ITEM];
const GROUP_LEGENDS = [YESTERDAY_LEGEND_ITEM, GROUP_LEGEND_ITEM];

const LEGENDS_MAPPING = {
  [DATE_ID]: DATE_LEGENDS,
  [MONTH_ID]: MONTH_LEGENDS,
  [GROUP_ID]: GROUP_LEGENDS,
};

export {
  DATE_ID,
  MONTH_ID,
  GROUP_ID,
  FEEDBACK_MODE_OBJECT,
  FEEDBACK_MODES,
  LEGENDS_MAPPING,
  LEGEND_GRID_TYPE,
};
